import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AccountService} from '../account/account.service';
import {AuthenticationService} from '../common/services/authentication/authentication.service';
import {TranslateService} from '@ngx-translate/core';
import {RegisterAccountService} from '../register/register-account.service';
import {ErrorType} from '../common/enums/enums';
import {Localization} from "../common/enums/localization";
import {AccountSiteService} from '../common/services/account-site.service';
import {NextObserver} from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [AccountService, RegisterAccountService]
})
export class LoginComponent implements OnInit, OnDestroy {

  public hide = true;
  public errorMessage;
  public sub: any;
  public isLogInProccessing: boolean;
  public readonly Localization = Localization;

  constructor(
      private authService: AuthenticationService,
      private router: Router,
      private route: ActivatedRoute,
      private translate: TranslateService,
      private accountSiteService: AccountSiteService,
  ) {
  }

  ngOnInit() {
    this.isLogInProccessing = true;
    this.sub = this.route.queryParams.subscribe(params => {
      const magicLinkToken = params['token'];
      if (magicLinkToken != null) {
        this.authorizeMagicLinkToken(magicLinkToken);
      }
    });
  }

  public reidirectToLogin() {
    this.accountSiteService.goToLoginPage(false);
  }

  private authorizeMagicLinkToken(magicLinkToken: string) {
    this.isLogInProccessing = true;
    this.authService.doLoginUsingMagicLinkToken(magicLinkToken).subscribe(
      this.handleDoLoginResponse(() => this.isLogInProccessing = false));
  }

  private handleDoLoginResponse(completeLogic?: () => void): NextObserver<any> {
    return {
      next: res => {
        this.isLogInProccessing = false;
        this.errorMessage = null;
        switch (res.errorCode) {
          case ErrorType.OK:
            if (this.authService.doesUserHaveActiveSubscription()) {
              this.router.navigate(['/buildings']);
            } else {
              this.router.navigate(['/payment']);
            }
            break;
          case ErrorType.NOTCONFIRMED:
            this.errorMessage = this.translate.instant(Localization.PleaseCheckYourEmail);
            break;
          case ErrorType.SESSIONEXPIRED:
            this.errorMessage = this.translate.instant(Localization.SignInLinkExpired);
            break;
          default:
            this.errorMessage = this.translate.instant(Localization.LoginFailed);
            break;
        }
      },
      error: err => {
        this.isLogInProccessing = false;
        if (err.status === 401) {
          this.errorMessage = this.translate.instant(Localization.InvalidCredentials);
        } else if (err.status === 403) {
            this.errorMessage = this.translate.instant(Localization.NoManagerPermission);
        } else {
          this.errorMessage = this.translate.instant(Localization.LoginFailed);
        }
      },
      complete: completeLogic
    };
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
